module.exports = __webpack_public_path__ + "static/media/feature-gift-code1.d4030298.png";